import { render, staticRenderFns } from "./AllInternalAccountTable.vue?vue&type=template&id=2be67772&scoped=true&"
import script from "./AllInternalAccountTable.vue?vue&type=script&lang=js&"
export * from "./AllInternalAccountTable.vue?vue&type=script&lang=js&"
import style0 from "./AllInternalAccountTable.vue?vue&type=style&index=0&id=2be67772&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be67772",
  null
  
)

export default component.exports